export default __webpack_public_path__ + "static/visu@2x-a5462a508dedc369822536707e8e66f5.jpg";